import platform from './platform'
export default platform.inBrowser
